<!-- Menu Builder -->

/*eslint no-unused-vars: "error"*/

<template>
	<div class="main">
		<div class="title wi8_font">Menu Builder</div>

		<br/>
		<div class="t1">Menu ID:</div>
		<div class="val1">{{menu_id}}</div>
		<button @click="menu_id='user'">User</button>
		<button @click="menu_id='admin'">Admin</button>
		<button @click="menu_id='xxx'">Err</button>
	
		<br/>
		<div class="t1">Menu Type:</div>
		<div class="val1">{{menu_type}}</div>
		<button @click="menu_type='ico'">Icon</button>
		<button @click="menu_type='txt'">Text</button>
		<button @click="menu_type='xxx'">Err</button>
		
		<br/>
		<div class="t1">Show Title:</div>
		<div class="val1">{{show_title}}</div>
		<button @click="show_title='1'">True</button>
		<button @click="show_title='0'">False</button>
		<button @click="show_title='xxx'">Err</button>

		<br/><br/>
		<div class="frame1">
			<UniMenu
				:menu_id = "menu_id"
				:menu_type = "menu_type"
				:show_title = "show_title"
			/>
		</div>

	</div>
</template>

<script>

export default {
	data() {
		return {
			menu_id: "user",
			menu_type: "ico",
			show_title: '1',
		}
	},
}
</script>

<style scoped>
	.main {
		height: 100%;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 0px #009;
	}
	.title {
		color: #396;
	}
	.t1 {
		display: inline-block;
		width: 80px;
		height: 24px;
		overflow: hidden;
		vertical-align: top;
		border: solid 0px #C30;
	}
	.val1 {
		display: inline-block;
		width: 60px;
		height: 24px;
		overflow: hidden;
		vertical-align: top;
		color: #090;
		padding: 0px 0px 0px 10px;
		border: solid 0px #090;
	}
	.frame1 {
		width: 500px;
		height: 100px;
		overflow: hidden;
		border: solid 1px #369;
	}
	button {
		width: 60px;
	}
</style>
